// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"invite-people_wrapper__14PJi"};